export const COUNTRIES_GUID = {
  BRAZIL: 'a0c65915-5d0e-11e8-8998-02e9bd3f6ff0'
}
